// this is an autogenerated file from DesignSystem/LetterRecipientPicker/query-get-postal-addresses.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_LetterRecipientPicker($person_id: uuid!) {
  vaxiom_contact_method_associations(
    where: {
      person: { _id: { _eq: $person_id } }
      contact_method: { dtype: { _eq: "postal" } }
    }
  ) {
    id
    _id
    postal_address {
      _id
      id
      city
      zip
      state
      address_line1
    }
  }
}

`